import React, { Fragment, useEffect} from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import DocumentView from "../forms/DocumentView";

const RouteContainer: React.FC = () => {
    
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(()=>{
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    if (id === null || id ==="")
      navigate("/viewDocs");
    else{
      navigate("/viewDocs?id="+id);
    }
  },[])

  return (
    <Fragment>
      <Routes>
          <Route
            path="/viewDocs"
            element={
              <DocumentView />
            }
          />
        </Routes>
    </Fragment>
  );
};

export default RouteContainer;
